import React from 'react';
import clsx from 'clsx';
import { Backdrop, CircularProgress, Typography } from '@material-ui/core';
import { Logo } from '@rcg/ui-react';
import { BRAND } from '../../utils/constants';
import Theme from '../../utils/theme';
import CelebrityLoader from '../../assets/gif/celwr-loader.gif';
import useStyles from './useStyles';
import getBrand from '../../utils/getBrand';

const AirLoader = ({ open = false, status = '' }) => {
  const classes = useStyles();
  const isCelebrity = getBrand()?.id === BRAND.CELEBRITY;

  return (
    <Backdrop open={open} className={classes.backdrop}>
      <div className={classes.loaderContainer}>
        {isCelebrity ? (
          <img src={CelebrityLoader} alt="celebrity loading animation" />
        ) : (
          <>
            <CircularProgress className={classes.circularLoader} size="120px" thickness={1} />
            <Logo
              className={classes.loaderLogo}
              color={Theme.palette.primary.dark}
              width="42px"
              height="42px"
            />
          </>
        )}
      </div>
      {status && (
        <div className={clsx(classes.loaderTitle, isCelebrity ? classes.customLoaderTitle : '')}>
          <Typography>{status}</Typography>
        </div>
      )}
    </Backdrop>
  );
};

export default AirLoader;
